import { render, staticRenderFns } from "./private.vue?vue&type=template&id=46a8b5ac&"
import script from "./private.vue?vue&type=script&lang=ts&"
export * from "./private.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports